import React, { Component } from 'react';

import { Elements, StripeProvider} from 'react-stripe-elements';
import { Icon } from "antd";

import CheckoutForm from "../payment/CheckoutForm";

import './styles.less';

const DEFAULT_COST = 100;
const PUBLIC_STRIPE_API_KEY = 'pk_live_rbJxvmOFPBiODBHwPAwbF7Mn00ET5hy4nb'; // PROD data
// const PUBLIC_STRIPE_API_KEY = 'pk_test_DxNP8MDTYeRvYHVYEmKD5ra6002sQxl7XX'; // TEST data

class StripeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
    };
  }

  render() {
    const { options, user, events, handlerClosePopup } = this.props;
    const { openPopupPayment, selectPaymentEvent } = options;
    const isOpenPopup = openPopupPayment && openPopupPayment.length;
    const isPaymentPopup = openPopupPayment === 'payment';
    const headerTitle = isPaymentPopup ? 'Event purchase' : 'Add card';
    const currentEvent = (events && events.find(event => event.id === selectPaymentEvent)) || {};
    const { title, description, thumbnail, eventCost } = currentEvent;
    const price = eventCost || DEFAULT_COST;

    return (
      <StripeProvider apiKey={PUBLIC_STRIPE_API_KEY}>
        <div className={`payment-popup ${isOpenPopup ? 'open' : 'close'} ${isPaymentPopup ? 'event-type' : ''}`}>
          <h1>{headerTitle}</h1>
          {
            isPaymentPopup && (
              <div className="event-cost">
                <h5>
                  Event cost:
                  <span>{`${price} $`}</span>
                </h5>
              </div>
            )
          }

          {
            title && description && (
              <div className="event-description">
                <img src={thumbnail} alt=""/>

                <div className="event-content">
                  <h3>{title}</h3>
                  <p>{description}</p>
                </div>
              </div>
            )
          }

          <Elements>
            <CheckoutForm
              user={user}
              itemId={selectPaymentEvent}
              eventCost={price}
              formType={openPopupPayment}
            />
          </Elements>
          <div
            className="payment-popup-close"
            onClick={handlerClosePopup}
          >
            <Icon type="close" theme="outlined" />
          </div>
        </div>
      </StripeProvider>
    );
  }
}

export default StripeComponent;



// WEBPACK FOOTER //
// ./src/components/StripeComponent/StripeComponent.js